// extracted by mini-css-extract-plugin
module.exports = {"fields":"styles_fields__3VsLs","dniField":"styles_dniField__1aPdY"};